export class UserOrganisationRefreshed {
  static readonly type = '[User] UserOrganisationRefreshed';
}
